<template>
<el-container>
  <el-main>
      <div class="register-main">
        <div style="width: 400px; margin: 0 auto;" :style="{ 'padding-top': `${mainTop}px` }">
          <img src="/static/img/brandmark-design.svg" style="width: 100%;">
        </div>
        <div class="register-info">
          <div style="padding:6%;">
            <form class="el-form demo-ruleForm login-form">
              <div>
                <div class="login-name">{{$t('electronEmail')}}</div>
                <div class="el-form-item__content">
                  <div class="el-input">
                    <input type="text" autocomplete="off" class="el-input__inner" ref="emailinput" placeholder="Email" tabindex="1">
                  </div>
                </div>
              </div>
              <div class="marginTop40">
                <div class="login-name">{{$t('password')}}
                  <div style="display:inline-block; float:right;">
                    <router-link :to="{ name: 'forgetPass'}" class="forgotpassword" tabindex="4">{{$t('forgotPassword')}}?</router-link>
                  </div>
                </div>
                <div class="login el-form-item__content" style="margin-top: 10px;">
                  <el-input :type="eyeOpen === true ? 'password' : 'text'" v-model="pwdInput" placeholder="Password" v-on:input="search" @focus="showPassImg = true" @blur="showPassImg === true && pwdInput !== '' ? showPassImg = true : showPassImg = false" tabindex="2" ></el-input>
                  <img :src="eyeOpen === true ? eyeCloseImg : eyeOpenImg" class="eye" v-show="showPassImg" @click="eyeOpen === true ? eyeOpen = false : eyeOpen = true">
                  <span class="login-remind-text-faild" v-show="remindFaild">{{remindMsg}}</span>
                </div>
              </div>
              <div class="marginTop40" style="width: 100%;">
                <div style="width: 140px; margin: 0 auto;">
                  <el-button :class="{'login_send':!login_send_show}" @click="submitForm()" data-index="login-button" tabindex="3">Sign in</el-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
  </el-main>
  <publicFooter></publicFooter>
</el-container>
</template>
<script>
import {signIn} from '@/request/login.js'
import publicFooter from '@/components/public/publicFooter'

export default {
  name: 'login',
  components: {
    publicFooter
  },
  data () {
    return {
      remindFaild: false,
      inputEmail: '',
      login_send_show: false,
      pwdInput: '',
      remindMsg: 'Please enter your email address or password.',
      search_json: {},
      eyeOpenImg: '/static/img/login/eye-open.png',
      eyeCloseImg: '/static/img/login/eye-close.png',
      showPassImg: false,
      eyeOpen: true,
      mainTop: document.documentElement.clientHeight * 0.11
    }
  },
  mounted () {
    // 判断是否登陆
    var token = localStorage.getItem('token')
    if (token !== null) {
      localStorage.removeItem('token')
    }
    // 是否从忘记密码跳转过来 是否弹框
    var emailSendTips = sessionStorage.getItem('emailSendTips')
    if (emailSendTips !== null) {
      this.inputEmail = emailSendTips
    }
    // 是否从注册跳转过来 是否弹框
    var verifyEmailSendEmail = sessionStorage.getItem('verifyEmailSendEmail')
    if (verifyEmailSendEmail !== null) {
      this.inputEmail = verifyEmailSendEmail
    }
    // 下拉框关闭
    document.addEventListener('click', this.bodyCloseMenus)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.bodyCloseMenus)
  },
  methods: {
    search (event) {
      if (this.pwdInput !== '') {
        this.showPassImg = true
      } else {
        this.showPassImg = false
      }
    },
    loginChange (tab, event) {
      console.log(tab, event)
    },
    submitForm () {
      sessionStorage.removeItem('emailSendTips')
      this.login_send_show = true
      // var LoginWebsiteAddress = sessionStorage.getItem('LoginWebsiteAddress')
      var email = this.$refs['emailinput'].value
      if (email === '' || this.pwdInput === '') {
        this.remindMsg = 'Please enter your email address or password.'
        this.remindFaild = true
        return false
      } else if (this.pwdInput.length < 6) {
        this.remindMsg = 'Account or password incorrect, please re-enter.'
        this.remindFaild = true
        return false
      } else {
        // ^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+.([a-zA-Z]{2,4})$
        var pattern = /^([a-zA-Z]|[0-9])(\.|\w|-)+@([a-zA-Z0-9])(\.|\w|-)+\.([a-zA-Z]{2,})$/
        if (!pattern.test(email)) {
          this.remindFaild = true
          return false
        }
      }
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'email': email, 'password': this.pwdInput, 'time': time, 'sessionid': sessionid}
      var data = this.common.encryptionData(dataJson, this)

      signIn(data).then(res => {
        delete data.password
        var responseTime = parseInt(new Date().getTime())
        this.loadPageView(data, res, requestTime, responseTime)

        if (res.flag === '200') {
          localStorage.setItem('firstLogin', true)
          localStorage.setItem('token', res.data.token)
          let source = res.data.source
          if (source !== '' && source !== undefined && source !== null) {
            this.source = source
            var sourceExpiresAt = Date.now() + 3600000 * 5
            localStorage.setItem('source', this.source)
            localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
          } else {
            localStorage.removeItem('source')
            localStorage.removeItem('sourceExpiresAt')
          }
          // 登录成功，延迟1秒后进行跳转.
          setTimeout(() => {
            if (res.data.redirectPage !== 'HotelList') {
              this.$router.push({name: res.data.redirectPage, query: {'source': this.source}})
            } else { // 获取当前日期
              let d = new Date()
              var year = d.getFullYear()
              var month = d.getMonth()
              var tian = d.getDate()
              var dayNum = new Date(year, parseInt(month) + 1, 0).getDate()
              var startDate = tian
              var endDate = tian + 1
              var startMonth = month
              var endMonth = month
              var startYear = year
              var endYear = year
              if (startDate > dayNum) {
                startDate = parseInt(startDate) - parseInt(dayNum)
                startMonth += 1
              }
              if (endDate > dayNum) {
                endDate = parseInt(endDate) - parseInt(dayNum)
                endMonth += 1
              }
              if (startMonth >= 12) {
                startMonth = 0
                startYear += 1
              }
              if (endMonth >= 12) {
                endMonth = 0
                endYear += 1
              }
              var monthStartSelect = (startMonth + 1) < 10 ? '0' + (startMonth + 1).toString() : (startMonth + 1).toString()
              var monthEndSelect = (endMonth + 1) < 10 ? '0' + (endMonth + 1).toString() : (endMonth + 1).toString()
              var startDateSelect = startDate < 10 ? '0' + startDate.toString() : startDate.toString()
              var endDateSelect = endDate < 10 ? '0' + endDate.toString() : endDate.toString()
              let startDateInfo = startYear + '-' + monthStartSelect + '-' + startDateSelect
              let endDateInfo = endYear + '-' + monthEndSelect + '-' + endDateSelect

              this.search_json['start_date'] = startDateInfo
              this.search_json['end_date'] = endDateInfo
              this.search_json['room'] = 1
              this.search_json['adult'] = 2
              this.search_json['child'] = 0
              this.search_json['childNums'] = []
              this.search_json['type'] = this.common.defaultRegionType
              this.search_json['type_id'] = this.common.defaultRegionId
              this.search_json['region'] = this.common.defaultRegion
              this.search_json['source'] = source
              this.$router.push({name: 'HotelList', query: this.search_json})
            }
          }, 500)
        } else {
          this.remindMsg = 'Account or password incorrect, please re-enter.'
          this.remindFaild = true
        }
      })
    },
    bodyCloseMenus: function (node) {
      if (node.target.getAttribute('data-index') !== 'login-button') {
        if (this.login_send_show === true) {
          this.login_send_show = false
        }
      }
    }
  }
}
</script>

<style scoped>
.el-main{background-color: rgba(83,102,161,0.37)}
.register-main{width:100%;padding-bottom:10px; margin:0 auto;height: 100vh;}
.register-info{width: 520px;margin: 0 auto;background-color: rgba(255, 255, 255, 0.6);border: none;border-radius: 5px; margin-top:72px;}
.forgotpassword{color: rgba(83, 102, 163, 1);text-decoration: none;}
.forgotpassword:hover{color: #296FF7;}
.login-form{margin:15px 0px; color:#606266;font-size: 14px;}
.login-form input{ margin-top:10px;}
/deep/ .el-button, .login_send{width: 140px;height: 40px; font-size:14px; background-color: rgba(83, 102, 163, 1);border: 1px solid rgba(83, 102, 163, 1);border-radius: 5px;color: #FFFFFF;}
/deep/ .login_send:hover{background-color: #FFF; border: 1px solid rgba(83, 102, 163, 1); color:rgba(83, 102, 163, 1);}
.marginTop40{margin-top: 40px;}
.marginTop35{margin-top: 35px;}
.marginTop25{margin-top: 25px;}
.marginTop15{margin-top: 15px;}
.marginTop10{margin-top: 10px;}
.marginLeft0{margin-left: 0px !important;}
.el-form-item__content{height: 40px;}
/deep/ .el-input__inner:focus{border-color:rgba(83, 102, 163, 1);box-shadow:0px 0px 8px rgba(83, 102, 163, 1);}
/deep/ .el-button:focus, .el-button:hover{width: 140px;height: 40px; font-size:14px;background-color: #FFF; border: 1px solid rgba(83, 102, 163, 1); color:rgba(83, 102, 163, 1);}
.login /deep/ .el-input__inner{padding: 0 45px 0 15px;}
.eye{height: 15px; width: 15px; position: absolute;top: 12.5px; right: 15px; cursor: pointer;}
/*提示*/
.login-remind-notice{border-width: 0px;min-height: 56px;background: inherit;border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.login-remind-notice-text{line-height: 20px; font-size: 14px;font-weight: 400;color:#5392F9;display:inline-block;width:90%;margin-top:10px}
.login-remind-notice img {width: 18px;height: 18px;margin-right: 5px;}
/* 登录提醒 */
.login-remind{ border-width: 0px;height: 56px;background: inherit;background-color: rgba(240, 249, 235);border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.login-remindinfo{padding-right: 18px;display: flex;justify-content: center;align-items: center; line-height:56px;}
.login-img{ margin: 18px;width: 18px;height: 18px;background-color: rgba(103, 194, 58, 1);border: none;border-radius: 15px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;text-align: center;line-height: normal;display:inline-block; margin-right:10px;}
.login-remind-text{color: #67C23A;line-height: 20px; font-size:14px;display:inline-block;width:90%;}
/* 失败 */
.login-remind-faild{overflow: hidden;background: inherit;background-color: rgba(254, 240, 240, 1);border-width: 0px;height: 56px;border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.login-img-faild{margin: 18px;width: 18px;height: 18px;background-color: rgba(245, 108, 108, 1);border: none;border-radius: 15px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;text-align: center;line-height: normal;display:inline-block; margin-right:10px;}
.login-remind-text-faild{color: #FF001F;font-size: 10px;display: block;margin-top: -8px;}
.codeError,.codeError:focus,.codeError:hover{background: inherit;background-color: rgba(255, 255, 255, 1);box-sizing: border-box;border: 2px solid rgba(225, 45, 45, 1);border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.mybox-leave-active,
.mybox-enter-active {
  transition: all 1s ease;
}

.mybox-leave-active,
.mybox-enter {
  height: 0px !important;
}

.mybox-leave,
.mybox-enter-active {
  height: 56px;
}
@media only screen and (min-width:431px) and (max-width:600px) {
  .register-info{width: 420px;
    margin: 0 auto;
    margin-top: -100px;
    background-color: rgba(255, 255, 255, 0.6);
    border: none;
    border-radius: 5px;
  }
}
@media only screen and (min-width:391px) and (max-width:430px) {
  .register-info{width: 380px;
    margin: 0 auto;
    margin-top: -100px;
    background-color: rgba(255, 255, 255, 0.6);
    border: none;
    border-radius: 5px;
  }
}
@media only screen and (max-width:390px) {
  .register-info{width: 350px;
    margin: 0 auto;
    margin-top: -100px;
    background-color: rgba(255, 255, 255, 0.6);
    border: none;
    border-radius: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue